export const EXCMTEAM_SHOW_RESET = 'EXCMTEAM_SHOW_RESET'
export const EXCMTEAM_SHOW_SET_ERROR = 'EXCMTEAM_SHOW_SET_ERROR'
export const EXCMTEAM_SHOW_SET_RETRIEVED = 'EXCMTEAM_SHOW_SET_RETRIEVED'
export const EXCMTEAM_SHOW_TOGGLE_LOADING = 'EXCMTEAM_SHOW_TOGGLE_LOADING'
